import { MonthName } from "@/app/reports/utils/enums";

const titleStyles = { color: "#595959", fontWeight: 600, fontSize: "14px" };

/**
 *
 * @param {Object} params Custom configuration of the chart
 * @param {Object} params.xAxis X axis configuration
 * @param {String} params.xAxis.title Title of the x axis
 * @param {Array} params.xAxis.categories Category names of the x axis
 * @param {Object} params.yAxis Y axis configuration
 * @param {String} params.yAxis.title Title of the x axis
 * @param {Array} params.chartColors Colors of the chart graphics
 * @param {Object} params.legend Configuration of the legend - From the apexchart Legend Option
 *
 * @returns Apex Chart Configuration Object
 */

export function getChartOptions({
  xAxis = {},
  yAxis = {},
  chartColors = [],
  singleBar = false,
  curve = "smooth",
  legend = { show: false },
} = {}) {
  const baseOptions = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      title: { text: xAxis.title, style: titleStyles },
      categories: xAxis.categories,
    },
    yaxis: {
      title: { text: yAxis.title, style: titleStyles, offsetX: 2 },
      labels: {
        formatter: (val) => {
          if (val >= 1000) return `${val / 1000} k`;
          else return val;
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => val,
      },
    },
    stroke: {
      width: 2,
      curve,
    },
    colors: chartColors,
    fill: {
      opacity: 0.8,
    },
    plotOptions: {
      bar: {
        distributed: singleBar,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend,
  };

  return baseOptions;
}

export const getChartLabels = (date) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, month] = date?.split("-");
  const labels = [];

  for (let i = 1; i <= 31; i++) {
    const dayNumber = String(i).padStart(2, "0");

    const day = `${MonthName[month]}-${dayNumber}`;

    labels.push(day);
  }

  return labels;
};

/**
 *
 * @param {Object} dataObject Object with the data of the correspondent series
 *
 * @returns {Array} Array with length 31 with all days per month based on the data we have
 */
export const getTableSeriesBasedOnDays = ({ dataObject } = {}) => {
  const daysArray = new Array(31).fill(0);

  for (let day in dataObject) {
    const dayNumber = Number(day);

    if (dayNumber) daysArray[dayNumber - 1] = dataObject[day];
  }

  return daysArray;
};
